<template>
  <div>
    <transition name="modal">
      <div
        class="modal-mask"
        @click="onClickMask"
      >
        <div
          class="modal-container"
          :class="{
            'modal-container--auto-height': autoHeight,
            'modal-container--wide': wide,
            'modal-container--fullscreen': fullScreen,
            'modal-container--tall': tall,
          }"
          @click.stop
        >
          <button
            v-if="closeButton"
            ref="closeButton"
            class="modal-close"
            data-test="modal-button-close"
            @click="close"
          >
            <span class="fal fa-times" />
          </button>

          <div
            v-if="header"
            class="modal-header"
          >
            <slot name="modal-header" />
          </div>

          <div class="modal-body">
            <slot name="modal-body" />
          </div>

          <div
            v-if="footer"
            class="modal-footer"
          >
            <slot name="modal-footer" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  emits: ['close'],
  props: {
    header: {
      type: Boolean,
      default: false,
    },

    footer: {
      type: Boolean,
      default: false,
    },

    disableClickOutside: {
      type: Boolean,
      default: false,
    },

    // Whether or not to automatically scale height of modal to fit contents
    // If false, container will expand to fit height of screen
    autoHeight: {
      type: Boolean,
      default: false,
    },

    // show a taller modal
    tall: {
      type: Boolean,
      default: false,
    },

    // show a wider modal
    wide: {
      type: Boolean,
      default: false,
    },

    // show a "single post" modal
    fullScreen: {
      type: Boolean,
      default: false,
    },

    // Whether or not to add the close button (times icon) to top-right corner
    closeButton: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    document.addEventListener('keydown', this.onKeyDown);

    if (this.closeButton) {
      this.$refs.closeButton.focus();
    }
  },

  beforeUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
  },
  methods: {
    onClickMask() {
      if (!this.disableClickOutside) {
        this.close();
      }
    },
    close() {
      this.$emit('close');
    },

    onKeyDown(e) {
      if (e.key === 'Escape') {
        this.close();
      }
    },
  },
};
</script>
